import Crown from "./images/svg/crown.svg";
import Info from "./images/svg/info.svg";
import Check from "./images/svg/check.svg";
import SearchIcon from "./images/svg/search_icon.svg";
import FilterIcon from "./images/svg/filterIcon.svg";
import DownArrow from "./images/svg/Down.svg";
import UpArrow from "./images/svg/Up.svg";
import Bookmarks from "./images/svg/bookmark.svg";
import Book from "./images/svg/books.svg";
import Clock from "./images/svg/clock.svg";
import Lock from "./images/svg/lock.svg";
import BookMarkSave from "./images/svg/bookmarkSave.svg";
import BackArrow from "./images/svg/backArrow.svg";
import PracticeTestBG from "./images/svg/practiceTestBg.svg";
import PracticeTestArt from "./images/svg/practiceTestArt.svg";
import IcPracticeTest from "./images/svg/ic_practice_test.svg";
import IcRightIcon from "./images/svg/right_icon.svg";
import Circle1 from "./images/svg/thick_circle_overlay.svg";
import Circle2 from "./images/svg/circle_2.svg";
import Circle3 from "./images/svg/circle_3.svg";
import ChangeIcon from "./images/svg/change_exam.svg";
import HomeIcon from "./images/svg/Home_icon.svg";
import dashboardIcon from "./images/svg/dashboard_icon.svg";
import {
  PREMIUM_BACKGROUND,

  THEME_BORDER,
  THEME_BORDER_DARK_MODE,
  THEME_DARK,
  THEME_DARK_MODE,

} from "../../app_constant";

import { getClientLogoByDomain, loadThemeColors } from "../api/theme_settings";
import { createLogger } from "../utils/logger";
const logger = createLogger(process.env.REACT_APP_ENV === 'DEVELOPMENT', 'Assets');

let colorData = null;

const initTheme = async () => {
  const colors = await loadThemeColors();

  if (colors) {
    colorData = colors;
  }
  logger.log("colorData", colorData);
};

await initTheme();

const getColors = () => {
  if (!colorData) {
    throw new Error("Theme colors are not loaded yet.");
  }
  return colorData;
};

export const COLORS = (() => {
  const { MAIN_THEME_COLORS, MAIN_LIGHT_THEME_COLORS, MAIN_DARK_THEME_COLORS } = getColors();

  return {
    NORMAL_COLOR_WHITE: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    NORMAL_COLOR_BLACK: MAIN_THEME_COLORS.NORMAL_COLOR_BLACK,

    LIGHT_BACKGROUND: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    DARK_BACKGROUND: MAIN_THEME_COLORS.DARK_BACKGROUND,

    SIDEBAR_BACKGROUND: MAIN_LIGHT_THEME_COLORS.SIDEBAR_BACKGROUND,
    SIDEBAR_COLOR: MAIN_LIGHT_THEME_COLORS.SIDEBAR_COLOR,

    //THEME COLORS
    THEME_DARK: THEME_DARK,
    THEME_LIGHT: MAIN_THEME_COLORS.THEME_LIGHT,
    THEME_SCORE_CONTAINER: MAIN_THEME_COLORS.COLOR_LZ_ORANGE, //LZ_ORANGE
    THEME_INPUT_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_SEPERATER: MAIN_LIGHT_THEME_COLORS.THEME_SEPERATER,
    THEME_FLASH_CARDS_SEPERATER: MAIN_LIGHT_THEME_COLORS.THEME_FLASH_CARDS_SEPERATER,
    THEME_PREMIUM_BACKGROUND: PREMIUM_BACKGROUND,

    //TUTORIAL
    THEME_TUTORIAL_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_TUTORIAL_BACKGROUND,
    THEME_TUTORIAL_DETAILS_BACKGROUND: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,

    //QUESTION & COMMUNITY COLOR
    COLOR_GREEN: MAIN_LIGHT_THEME_COLORS.COLOR_GREEN,
    COLOR_YELLOW: MAIN_LIGHT_THEME_COLORS.COLOR_YELLOW,
    COLOR_RED: MAIN_LIGHT_THEME_COLORS.COLOR_RED,

    //QUICK ASSESSMENT BACKGROUND
    BLUE_GREDIENT: MAIN_LIGHT_THEME_COLORS.BLUE_GREDIENT,
    ORANGE_GREDIENT: MAIN_LIGHT_THEME_COLORS.ORANGE_GREDIENT,

    //TIMER
    TIMER_20_SECOND_BACKGROUND: MAIN_LIGHT_THEME_COLORS.TIMER_20_SECOND_BACKGROUND,
    TIMER_30_SECOND_BACKGROUND: MAIN_LIGHT_THEME_COLORS.TIMER_30_SECOND_BACKGROUND,
    TIMER_BACKGROUND: MAIN_LIGHT_THEME_COLORS.TIMER_BACKGROUND,

    //BACKGROUND COLOR
    THEME_SCREEN_BACKGROUND_COLOR: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    THEME_SCREEN_BACKGROUND_ALPHA: MAIN_LIGHT_THEME_COLORS.THEME_SCREEN_BACKGROUND_ALPHA,

    //TEXT COLOR
    THEME_TEXT_BLACK: MAIN_LIGHT_THEME_COLORS.THEME_TEXT_BLACK,
    THEME_TEXT_BLACK_LIGHT: MAIN_LIGHT_THEME_COLORS.THEME_TEXT_BLACK_LIGHT,
    THEME_TEXT_GRAY: MAIN_LIGHT_THEME_COLORS.THEME_TEXT_GRAY,

    TABBAR_BACKGROUND: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    TABBAR_LANDSCAPE_BG: MAIN_LIGHT_THEME_COLORS.TABBAR_LANDSCAPE_BG,
    TAABAR_UNSELECTED_COLOR: MAIN_LIGHT_THEME_COLORS.TAABAR_UNSELECTED_COLOR,
    HEADER_ICON_BORDER: MAIN_LIGHT_THEME_COLORS.HEADER_ICON_BORDER,
    THEMER_FILTER_ITEM_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEMER_FILTER_ITEM_BACKGROUND,

    //HOME

    THEME_STUDY_QUESTION_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_STUDY_QUESTION_BACKGROUND,
    THEME_STUDY_QUESTION_BACKGROUND_LEFT: MAIN_LIGHT_THEME_COLORS.THEME_STUDY_QUESTION_BACKGROUND_LEFT,
    THEME_STUDY_QUESTION_BACKGROUND_RIGHT: MAIN_LIGHT_THEME_COLORS.THEME_STUDY_QUESTION_BACKGROUND_RIGHT,

    THEME_PRACTICE_TEST_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_PRACTICE_TEST_BACKGROUND,
    THEME_PRACTICE_TEST_BACKGROUND_LEFT: MAIN_LIGHT_THEME_COLORS.THEME_PRACTICE_TEST_BACKGROUND_LEFT,
    THEME_PRACTICE_TEST_BACKGROUND_RIGHT: MAIN_LIGHT_THEME_COLORS.THEME_PRACTICE_TEST_BACKGROUND_RIGHT,

    THEME_FLASHCARD_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_FLASHCARD_BACKGROUND,
    THEME_FLASHCARD_BACKGROUND_LEFT: MAIN_LIGHT_THEME_COLORS.THEME_FLASHCARD_BACKGROUND_LEFT,
    THEME_FLASHCARD_BACKGROUND_RIGHT: MAIN_LIGHT_THEME_COLORS.THEME_FLASHCARD_BACKGROUND_RIGHT,

    THEME_CUSTOM_TEST_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_CUSTOM_TEST_BACKGROUND,
    THEME_CUSTOM_TEST_BACKGROUND_LEFT: MAIN_LIGHT_THEME_COLORS.THEME_CUSTOM_TEST_BACKGROUND_LEFT,
    THEME_CUSTOM_TEST_BACKGROUND_RIGHT: MAIN_LIGHT_THEME_COLORS.THEME_CUSTOM_TEST_BACKGROUND_RIGHT,

    THEME_STUDY_ICON_BACKGROUND_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR,
    THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR,
    THEME_FLASHCARD_ICON_BACKGROUND_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR,
    THEME_CUSTOM_ICON_BACKGROUND_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR,

    //PROFILE
    THEME_MENU_TEXT_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_MENU_TEXT_COLOR,

    //HISTORY
    THEME_HISTORY_PROGRESS_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_HISTORY_PROGRESS_COLOR,
    THEME_HISTORY_OVERALL_TITLE_COLOR: MAIN_LIGHT_THEME_COLORS.THEME_HISTORY_OVERALL_TITLE_COLOR,
    THEME_CIRCLE_PROGRESS_BG: MAIN_LIGHT_THEME_COLORS.THEME_CIRCLE_PROGRESS_BG,
    THEME_FOTTER_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_FOTTER_BACKGROUND,

    //REVIEW TEST
    THEME_TEST_REVIEW_ITEM_BACKGROUND: MAIN_LIGHT_THEME_COLORS.THEME_TEST_REVIEW_ITEM_BACKGROUND,

    //POPUP BACKGROUND COLOR
    MODAL_BACKGROUND_COLOR: MAIN_LIGHT_THEME_COLORS.MODAL_BACKGROUND_COLOR,

    THEME_FILTER_SELECTION: MAIN_THEME_COLORS.THEME_LIGHT,
    THEME_FILTER_BACKGROUND: MAIN_THEME_COLORS.THEME_LIGHT,

    COLOR_LZ_BLUE: MAIN_THEME_COLORS.COLOR_LZ_BLUE,
    COLOR_LZ_BLUE_1: MAIN_THEME_COLORS.COLOR_LZ_BLUE_1,
    COLOR_LZ_BLUE_2: MAIN_THEME_COLORS.COLOR_LZ_BLUE_2,
    COLOR_LZ_BLUE_3: MAIN_THEME_COLORS.COLOR_LZ_BLUE_3,
    COLOR_LZ_BLUE_4: MAIN_THEME_COLORS.COLOR_LZ_BLUE_4,
    COLOR_LZ_BLUE_5: MAIN_THEME_COLORS.COLOR_LZ_BLUE_5,
    COLOR_LZ_BLUE_6: MAIN_THEME_COLORS.COLOR_LZ_BLUE_6,
    COLOR_LZ_BLUE_7: MAIN_THEME_COLORS.THEME_DARK_MODE,
    COLOR_LZ_BLUE_8: MAIN_THEME_COLORS.COLOR_LZ_BLUE_8,
    COLOR_LZ_BLUE_9: MAIN_THEME_COLORS.THEME_DARK_MODE,
    COLOR_LZ_BLUE_10: MAIN_THEME_COLORS.COLOR_LZ_BLUE_10,

    COLOR_LZ_ORANGE: MAIN_THEME_COLORS.COLOR_LZ_ORANGE,
    COLOR_LZ_ORANGE_1: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_1,
    COLOR_LZ_ORANGE_2: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_2,
    COLOR_LZ_ORANGE_3: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_3,
    COLOR_LZ_ORANGE_4: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_4,
    COLOR_LZ_ORANGE_5: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_5,
    COLOR_LZ_ORANGE_6: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_6,
    COLOR_LZ_ORANGE_7: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_7,
    COLOR_LZ_ORANGE_8: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_8,
    COLOR_LZ_ORANGE_9: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_9,
    COLOR_LZ_ORANGE_10: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_10,

    primary: {
      main: MAIN_THEME_COLORS.CLIENT_PRIMARY_MAIN,
      dark: MAIN_THEME_COLORS.CLIENT_PRIMARY_DARK,
      light: MAIN_THEME_COLORS.CLIENT_PRIMARY_LIGHT,
    },
    secondary: {
      main: MAIN_THEME_COLORS.CLIENT_SECONDARY_MAIN,
      dark: MAIN_THEME_COLORS.CLIENT_SECONDARY_DARK,
      light: MAIN_THEME_COLORS.CLIENT_SECONDARY_LIGHT,
      leftLight: MAIN_THEME_COLORS.CLIENT_SECONDARY_LEFT_LIGHT,
      leftDark: MAIN_THEME_COLORS.CLIENT_SECONDARY_LEFT_DARK,
      rightLight: MAIN_THEME_COLORS.CLIENT_SECONDARY_RIGHT_LIGHT,
      rightDark: MAIN_THEME_COLORS.CLIENT_SECONDARY_RIGHT_DARK,
    },
    background: {
      light: MAIN_THEME_COLORS.CLIENT_BG_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_BG_DARK,
      card: MAIN_THEME_COLORS.CLIENT_BACKGROUND_CARD,
      gradientStart: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_START,
      gradientEnd: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_END,
      gradientStartDark: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_START_DARK,
      gradientEndDark: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_END_DARK,
      sidebarLight: MAIN_THEME_COLORS.CLIENT_SIDEBAR_BACKGROUND_LIGHT,
      headerLight: MAIN_THEME_COLORS.CLIENT_HEADER_BACKGROUND_LIGHT,
      sidebarDark: MAIN_THEME_COLORS.CLIENT_SIDEBAR_BACKGROUND_DARK,
      headerDark: MAIN_THEME_COLORS.CLIENT_HEADER_BACKGROUND_DARK,
    },
    icon_bg: {
      study_light: MAIN_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR_LIGHT,
      practice_light: MAIN_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR_LIGHT,
      flashcard_light: MAIN_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR_LIGHT,
      custom_light: MAIN_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR_LIGHT,
      glossary_light: MAIN_THEME_COLORS.THEME_GLOSSARY_ICON_BACKGROUND_COLOR_LIGHT,
      acronym_light: MAIN_THEME_COLORS.THEME_ACRONYM_ICON_BACKGROUND_COLOR_LIGHT,
      study_dark: MAIN_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR_DARK,
      practice_dark: MAIN_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR_DARK,
      flashcard_dark: MAIN_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR_DARK,
      custom_dark: MAIN_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR_DARK,
      glossary_dark: MAIN_THEME_COLORS.THEME_GLOSSARY_ICON_BACKGROUND_COLOR_DARK,
      acronym_dark: MAIN_THEME_COLORS.THEME_ACRONYM_ICON_BACKGROUND_COLOR_DARK,
      profile_light: MAIN_THEME_COLORS.THEME_PROFILE_ICON_BACKGROUND_COLOR_LIGHT,
      profile_dark: MAIN_THEME_COLORS.THEME_PROFILE_ICON_BACKGROUND_COLOR_DARK,
    },
    homeCard: {
      start_light: MAIN_THEME_COLORS.CLIENT_HOME_CARD_START_LIGHT,
      end_light: MAIN_THEME_COLORS.CLIENT_HOME_CARD_END_LIGHT,
      start_dark: MAIN_THEME_COLORS.CLIENT_HOME_CARD_START_DARK,
      end_dark: MAIN_THEME_COLORS.CLIENT_HOME_CARD_END_DARK,
    },
    border: {
      light: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_BORDER_DARK,
      accent: MAIN_THEME_COLORS.CLIENT_BORDER_ACCENT,
    },
    status: {
      success: MAIN_THEME_COLORS.CLIENT_STATUS_SUCCESS,
      error: MAIN_THEME_COLORS.CLIENT_STATUS_ERROR,
      warning: MAIN_THEME_COLORS.CLIENT_STATUS_WARNING,
    },
    card: {
      light: MAIN_THEME_COLORS.CLIENT_CARD_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_CARD_DARK,
    },
    text: {
      login_primary: MAIN_LIGHT_THEME_COLORS.CLIENT_TEXT_PRIMARY,
      login_secondary: MAIN_LIGHT_THEME_COLORS.CLIENT_TEXT_SECONDARY,
      primary: MAIN_THEME_COLORS.CLIENT_TEXT_PRIMARY,
      secondary: MAIN_THEME_COLORS.CLIENT_TEXT_SECONDARY,
      light: MAIN_THEME_COLORS.CLIENT_TEXT_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_TEXT_DARK,
      muted: MAIN_THEME_COLORS.CLIENT_TEXT_MUTED,      // new: for placeholders and footer text
      link: MAIN_THEME_COLORS.CLIENT_TEXT_ACCENT,     // new: for links/buttons
    },
    

    color: {
      "red": {
        "main": "#DC3545",
        "light": "#F8D7DA",
        "dark": "#A71D2A"
      },
      "yellow": {
        "main": "#FFC107",
        "light": "#FFF3CD",
        "dark": "#B38F00"
      },
      "green": {
        "main": "#28A745",
        "light": "#D4EDDA",
        "dark": "#1E7E34"
      },
      "gray": {
        "light": "#e5e7eb",
        "main": "#6b7280",
        "dark": "#374151",
      }
    },
    

    // new top‑level groups
    input: {
      background: MAIN_THEME_COLORS.CLIENT_INPUT_BACKGROUND,  // e.g. same as theme.background.card or a slightly lighter
      border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      placeholder: MAIN_THEME_COLORS.CLIENT_TEXT_MUTED,
    },
    button: {
      primary: {
        background: MAIN_THEME_COLORS.CLIENT_SECONDARY_MAIN,
        text: MAIN_THEME_COLORS.CLIENT_TEXT_PRIMARY,
        border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      },
      secondary: {
        background: MAIN_THEME_COLORS.CLIENT_PRIMARY_MAIN,
        text: MAIN_THEME_COLORS.CLIENT_TEXT_SECONDARY,
        border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      },
    },
    divider: {
      light: MAIN_THEME_COLORS.CLIENT_DIVIDER_LIGHT,           // e.g. rgba(21,101,192,0.1)
      dark: MAIN_THEME_COLORS.CLIENT_DIVIDER_DARK,            // e.g. rgba(176,190,197,0.1)
    },
    option: {
      selected: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_DARK,
      },
      unselected: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_UNSELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_UNSELECTED_DARK,
      },
      hover: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_DARK,
      },
    },

  };
})();

export const COLORS_DARK = (() => {
  const { MAIN_THEME_COLORS, MAIN_LIGHT_THEME_COLORS, MAIN_DARK_THEME_COLORS } = getColors();

  return {
    NORMAL_COLOR_WHITE: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    NORMAL_COLOR_BLACK: MAIN_THEME_COLORS.NORMAL_COLOR_BLACK,

    LIGHT_BACKGROUND: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    DARK_BACKGROUND: MAIN_THEME_COLORS.DARK_BACKGROUND,

    SIDEBAR_BACKGROUND: MAIN_DARK_THEME_COLORS.SIDEBAR_BACKGROUND,
    SIDEBAR_COLOR: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,

    //THEME COLORS
    THEME_DARK: THEME_DARK_MODE,
    THEME_LIGHT: MAIN_THEME_COLORS.THEME_LIGHT,
    THEME_SCORE_CONTAINER: MAIN_THEME_COLORS.COLOR_LZ_ORANGE,
    THEME_INPUT_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_SEPERATER: MAIN_DARK_THEME_COLORS.THEME_SEPERATER,
    THEME_FLASH_CARDS_SEPERATER: MAIN_DARK_THEME_COLORS.THEME_FLASH_CARDS_SEPERATER,
    THEME_PREMIUM_BACKGROUND: THEME_DARK_MODE,

    //TUTORIAL
    THEME_TUTORIAL_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_TUTORIAL_BACKGROUND,
    THEME_TUTORIAL_DETAILS_BACKGROUND: MAIN_DARK_THEME_COLORS.SIDEBAR_BACKGROUND,

    //QUESTION & COMMUNITY COLOR
    COLOR_GREEN: MAIN_DARK_THEME_COLORS.COLOR_GREEN,
    COLOR_YELLOW: MAIN_DARK_THEME_COLORS.COLOR_YELLOW,
    COLOR_RED: MAIN_DARK_THEME_COLORS.COLOR_RED,

    //QUICK ASSESSMENT BACKGROUND
    BLUE_GREDIENT: MAIN_DARK_THEME_COLORS.BLUE_GREDIENT,
    ORANGE_GREDIENT: MAIN_DARK_THEME_COLORS.ORANGE_GREDIENT,

    //TIMER
    TIMER_20_SECOND_BACKGROUND: MAIN_DARK_THEME_COLORS.TIMER_20_SECOND_BACKGROUND,
    TIMER_30_SECOND_BACKGROUND: MAIN_DARK_THEME_COLORS.TIMER_BACKGROUND,
    TIMER_BACKGROUND: MAIN_DARK_THEME_COLORS.TIMER_BACKGROUND,

    //BACKGROUND COLOR
    THEME_SCREEN_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.THEME_SCREEN_BACKGROUND_COLOR,
    THEME_SCREEN_BACKGROUND_ALPHA: MAIN_DARK_THEME_COLORS.THEME_SCREEN_BACKGROUND_ALPHA,

    //TEXT COLOR
    THEME_TEXT_BLACK: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    THEME_TEXT_BLACK_LIGHT: MAIN_DARK_THEME_COLORS.THEME_TEXT_BLACK_LIGHT,
    THEME_TEXT_GRAY: MAIN_DARK_THEME_COLORS.THEME_TEXT_GRAY,

    TABBAR_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    TABBAR_LANDSCAPE_BG: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    TAABAR_UNSELECTED_COLOR: MAIN_THEME_COLORS.TAABAR_UNSELECTED_COLOR,
    HEADER_ICON_BORDER: MAIN_DARK_THEME_COLORS.HEADER_ICON_BORDER,
    THEMER_FILTER_ITEM_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,

    //HOME
    THEME_STUDY_QUESTION_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_PRACTICE_TEST_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_FLASHCARD_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_CUSTOM_TEST_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,
    THEME_STUDY_ICON_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR,
    THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR,
    THEME_FLASHCARD_ICON_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR,
    THEME_CUSTOM_ICON_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR,

    //PROFILE
    THEME_MENU_TEXT_COLOR: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,

    //HISTORY
    THEME_HISTORY_PROGRESS_COLOR: MAIN_DARK_THEME_COLORS.THEME_TEXT_GRAY,
    THEME_HISTORY_OVERALL_TITLE_COLOR: MAIN_DARK_THEME_COLORS.THEME_HISTORY_OVERALL_TITLE_COLOR,
    THEME_CIRCLE_PROGRESS_BG: MAIN_DARK_THEME_COLORS.THEME_CIRCLE_PROGRESS_BG,
    THEME_FOTTER_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_TUTORIAL_BACKGROUND,

    //REVIEW TEST
    THEME_TEST_REVIEW_ITEM_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_INPUT_BACKGROUND,

    //POPUP BACKGROUND COLOR
    MODAL_BACKGROUND_COLOR: MAIN_DARK_THEME_COLORS.MODAL_BACKGROUND_COLOR,

    THEME_FILTER_SELECTION: MAIN_DARK_THEME_COLORS.THEME_FILTER_SELECTION,
    THEME_FILTER_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_FLASHCARD_BACKGROUND,

    THEME_FILTER_SELECTION: MAIN_THEME_COLORS.NORMAL_COLOR_WHITE,
    THEME_FILTER_BACKGROUND: MAIN_DARK_THEME_COLORS.THEME_CIRCLE_PROGRESS_BG,

    COLOR_LZ_BLUE: MAIN_THEME_COLORS.COLOR_LZ_BLUE,
    COLOR_LZ_BLUE_1: MAIN_THEME_COLORS.COLOR_LZ_BLUE_1,
    COLOR_LZ_BLUE_2: MAIN_THEME_COLORS.COLOR_LZ_BLUE_2,
    COLOR_LZ_BLUE_3: MAIN_THEME_COLORS.COLOR_LZ_BLUE_3,
    COLOR_LZ_BLUE_4: MAIN_THEME_COLORS.COLOR_LZ_BLUE_4,
    COLOR_LZ_BLUE_5: MAIN_THEME_COLORS.COLOR_LZ_BLUE_5,
    COLOR_LZ_BLUE_6: MAIN_THEME_COLORS.COLOR_LZ_BLUE_6,
    COLOR_LZ_BLUE_7: MAIN_THEME_COLORS.THEME_DARK_MODE,
    COLOR_LZ_BLUE_8: MAIN_THEME_COLORS.COLOR_LZ_BLUE_8,
    COLOR_LZ_BLUE_9: MAIN_THEME_COLORS.THEME_DARK_MODE,
    COLOR_LZ_BLUE_10: MAIN_THEME_COLORS.COLOR_LZ_BLUE_10,

    COLOR_LZ_ORANGE: MAIN_THEME_COLORS.COLOR_LZ_ORANGE,
    COLOR_LZ_ORANGE_1: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_1,
    COLOR_LZ_ORANGE_2: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_2,
    COLOR_LZ_ORANGE_3: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_3,
    COLOR_LZ_ORANGE_4: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_4,
    COLOR_LZ_ORANGE_5: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_5,
    COLOR_LZ_ORANGE_6: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_6,
    COLOR_LZ_ORANGE_7: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_7,
    COLOR_LZ_ORANGE_8: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_8,
    COLOR_LZ_ORANGE_9: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_9,
    COLOR_LZ_ORANGE_10: MAIN_THEME_COLORS.COLOR_LZ_ORANGE_10,

    primary: {
      main: MAIN_THEME_COLORS.CLIENT_PRIMARY_MAIN,
      dark: MAIN_THEME_COLORS.CLIENT_PRIMARY_DARK,
      light: MAIN_THEME_COLORS.CLIENT_PRIMARY_LIGHT,
    },
    secondary: {
      main: MAIN_THEME_COLORS.CLIENT_SECONDARY_MAIN,
      dark: MAIN_THEME_COLORS.CLIENT_SECONDARY_DARK,
      light: MAIN_THEME_COLORS.CLIENT_SECONDARY_LIGHT,
      leftLight: MAIN_THEME_COLORS.CLIENT_SECONDARY_LEFT_LIGHT,
      leftDark: MAIN_THEME_COLORS.CLIENT_SECONDARY_LEFT_DARK,
      rightLight: MAIN_THEME_COLORS.CLIENT_SECONDARY_RIGHT_LIGHT,
      rightDark: MAIN_THEME_COLORS.CLIENT_SECONDARY_RIGHT_DARK,
    },
    background: {
      light: MAIN_THEME_COLORS.CLIENT_BG_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_BG_DARK,
      card: MAIN_THEME_COLORS.CLIENT_BACKGROUND_CARD,
      gradientStart: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_START,
      gradientEnd: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_END,
      gradientStartDark: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_START_DARK,
      gradientEndDark: MAIN_THEME_COLORS.CLIENT_BG_GRADIENT_END_DARK,
      sidebarLight: MAIN_THEME_COLORS.CLIENT_SIDEBAR_BACKGROUND_LIGHT,
      headerLight: MAIN_THEME_COLORS.CLIENT_HEADER_BACKGROUND_LIGHT,
      sidebarDark: MAIN_THEME_COLORS.CLIENT_SIDEBAR_BACKGROUND_DARK,
      headerDark: MAIN_THEME_COLORS.CLIENT_HEADER_BACKGROUND_DARK,
    },
    icon_bg: {
      study_light: MAIN_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR_LIGHT,
      practice_light: MAIN_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR_LIGHT,
      flashcard_light: MAIN_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR_LIGHT,
      custom_light: MAIN_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR_LIGHT,
      glossary_light: MAIN_THEME_COLORS.THEME_GLOSSARY_ICON_BACKGROUND_COLOR_LIGHT,
      acronym_light: MAIN_THEME_COLORS.THEME_ACRONYM_ICON_BACKGROUND_COLOR_LIGHT,
      study_dark: MAIN_THEME_COLORS.THEME_STUDY_ICON_BACKGROUND_COLOR_DARK,
      practice_dark: MAIN_THEME_COLORS.THEME_PRACTICE_TEST_ICON_BACKGROUND_COLOR_DARK,
      flashcard_dark: MAIN_THEME_COLORS.THEME_FLASHCARD_ICON_BACKGROUND_COLOR_DARK,
      custom_dark: MAIN_THEME_COLORS.THEME_CUSTOM_ICON_BACKGROUND_COLOR_DARK,
      glossary_dark: MAIN_THEME_COLORS.THEME_GLOSSARY_ICON_BACKGROUND_COLOR_DARK,
      acronym_dark: MAIN_THEME_COLORS.THEME_ACRONYM_ICON_BACKGROUND_COLOR_DARK,
      profile_light: MAIN_THEME_COLORS.THEME_PROFILE_ICON_BACKGROUND_COLOR_LIGHT,
      profile_dark: MAIN_THEME_COLORS.THEME_PROFILE_ICON_BACKGROUND_COLOR_DARK,
    },
    homeCard: {
      start_light: MAIN_THEME_COLORS.CLIENT_HOME_CARD_START_LIGHT,
      end_light: MAIN_THEME_COLORS.CLIENT_HOME_CARD_END_LIGHT,
      start_dark: MAIN_THEME_COLORS.CLIENT_HOME_CARD_START_DARK,
      end_dark: MAIN_THEME_COLORS.CLIENT_HOME_CARD_END_DARK,
    },
    border: {
      light: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_BORDER_DARK,
      accent: MAIN_THEME_COLORS.CLIENT_BORDER_ACCENT,
    },
    status: {
      success: MAIN_THEME_COLORS.CLIENT_STATUS_SUCCESS,
      error: MAIN_THEME_COLORS.CLIENT_STATUS_ERROR,
      warning: MAIN_THEME_COLORS.CLIENT_STATUS_WARNING,
    },
    card: {
      light: MAIN_THEME_COLORS.CLIENT_CARD_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_CARD_DARK,
    },
    text: {
      login_primary: MAIN_DARK_THEME_COLORS.CLIENT_TEXT_LOGIN_PRIMARY,
      login_secondary: MAIN_DARK_THEME_COLORS.CLIENT_TEXT_LOGIN_SECONDARY,
      primary: MAIN_THEME_COLORS.CLIENT_TEXT_PRIMARY,
      secondary: MAIN_THEME_COLORS.CLIENT_TEXT_SECONDARY,
      light: MAIN_THEME_COLORS.CLIENT_TEXT_LIGHT,
      dark: MAIN_THEME_COLORS.CLIENT_TEXT_DARK,
      muted: MAIN_THEME_COLORS.CLIENT_TEXT_MUTED,      // new: for placeholders and footer text
      link: MAIN_THEME_COLORS.CLIENT_TEXT_ACCENT,     // new: for links/buttons
    },
    

    color: {
      "red": {
        "main": "#EF5350",
        "light": "#FFCDD2",
        "dark": "#7F1C1C"
      },
      "yellow": {
        "main": "#FFEB3B",
        "light": "#FFF9C4",
        "dark": "#7D6500"
      },
      "green": {
        "main": "#66BB6A",
        "light": "#C8E6C9",
        "dark": "#2C6B2C"
      },
      "gray": {
        "light": "#1f2937",
        "main": "#6b7280",
        "dark": "#f3f4f6"
      }
    },

    // new top‑level groups
    input: {
      background: MAIN_THEME_COLORS.CLIENT_INPUT_BACKGROUND,  // e.g. same as theme.background.card or a slightly lighter
      border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      placeholder: MAIN_THEME_COLORS.CLIENT_TEXT_MUTED,
    },
    button: {
      primary: {
        background: MAIN_THEME_COLORS.CLIENT_SECONDARY_MAIN,
        text: MAIN_THEME_COLORS.CLIENT_TEXT_PRIMARY,
        border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      },
      secondary: {
        background: MAIN_THEME_COLORS.CLIENT_PRIMARY_MAIN,
        text: MAIN_THEME_COLORS.CLIENT_TEXT_SECONDARY,
        border: MAIN_THEME_COLORS.CLIENT_BORDER_LIGHT,
      },
    },
    divider: {
      light: MAIN_THEME_COLORS.CLIENT_DIVIDER_LIGHT,           // e.g. rgba(21,101,192,0.1)
      dark: MAIN_THEME_COLORS.CLIENT_DIVIDER_DARK,            // e.g. rgba(176,190,197,0.1)
    },
    option: {
      selected: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_DARK,
      },
      unselected: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_UNSELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_UNSELECTED_DARK,
      },
      hover: {
        light: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_LIGHT,
        dark: MAIN_THEME_COLORS.CLIENT_OPTION_SELECTED_DARK,
      },
    }
  };
})();


export const IMAGES = {
  client_logo_light: require("../../config/assets/client_logo_light.png"),
  client_logo_dark: require("../../config/assets/client_logo_dark.png"),
  background: require("./images/background.png"),
  ic_apple: require("./images/ic_apple.png"),
  ic_google: require("./images/ic_google.png"),
  ic_skip: require("./images/ic_skip.png"),
  slide_1: require("./images/slide_1.png"),
  slide_2: require("./images/slide_2.png"),
  slide_3: require("./images/slide_3.png"),
  slide_4: require("./images/slide_4.png"),
  slide_5: require("./images/slide_5.png"),
  ic_back: require("./images/ic_back.png"),
  info_background: require("./images/info_background.png"),
  logo: require('./images/logo_prepare.png'),
  crown: require("./images/crown.png"),
  price_crown: require("./images/price_crown.png"),
  quick_assessment: require("./images/quick_assessment.png"),
  ic_dark_mode: require("./images/ic_dark_mode.png"),
  ic_light_mode: require("./images/ic_light_mode.png"),
  ic_notification: require("./images/ic_notification.png"),
  ic_account: require("./images/ic_account.png"),
  ic_profile: require("./images/ic_profile.png"),
  ic_avatar: require("./images/ic_avatar.png"),
  ic_subscription: require("./images/ic_subscription.png"),
  ic_share_app: require("./images/ic_share_app.png"),
  ic_other_app: require("./images/ic_other_app.png"),
  ic_help: require("./images/ic_help.png"),
  ic_signout: require("./images/ic_signout.png"),
  ic_camera: require("./images/ic_camera.png"),
  ic_tab_home: require("./images/ic_tab_home.png"),
  ic_tab_dashboard: require("./images/ic_tab_dashboard.png"),
  ic_tab_hisotry: require("./images/ic_tab_hisotry.png"),
  ic_tab_study_plan: require("./images/ic_tab_study_plan.png"),
  ic_tab_bookmark: require("./images/ic_tab_bookmark.png"),
  ic_notification_home: require("./images/ic_notification_home.png"),
  ic_user_home: require("./images/ic_user_home.png"),
  ic_input_cancel: require("./images/ic_input_cancel.png"),
  ic_email: require("./images/ic_email.png"),
  ic_lock: require("./images/ic_lock.png"),
  ic_eye_hidden: require("./images/ic_eye_hidden.png"),
  ic_view: require("./images/ic_view.png"),
  ic_hide: require("./images/ic_hide.png"),
  ic_check: require("./images/ic_check.png"),
  ic_check_white: require("./images/ic_check_white.png"),
  ic_free_rect: require("./images/ic_free_rect.png"),
  ic_save: require("./images/ic_save.png"),
  ic_edit: require("./images/ic_edit.png"),
  ic_info_close: require("./images/ic_info_close.png"),
  ic_read: require("./images/ic_read.png"),
  ic_easy_test: require("./images/ic_easy_test.png"),
  ic_hard_test: require("./images/ic_hard_test.png"),
  ic_premium: require("./images/ic_premium.png"),
  ic_home_custom: require("./images/ic_home_custom.png"),
  ic_home_flash: require("./images/ic_home_flash.png"),
  ic_home_quiz: require("./images/ic_home_quiz.png"),
  ic_home_practice: require("./images/ic_home_practice.png"),
  ic_menu: require("./images/ic_menu.png"),
  ic_plus: require("./images/ic_plus.png"),
  ic_down_arrow: require("./images/ic_down_arrow.png"),
  ic_delete: require("./images/ic_delete.png"),
  ic_search: require("./images/ic_search.png"),
  ic_timer: require("./images/ic_timer.png"),
  ic_previous: require("./images/ic_previous.png"),
  flash_bg: require("./images/flash_bg.png"),
  ic_up_arrow: require("./images/ic_up_arrow.png"),
  ic_score_circle: require("./images/ic_score_circle.png"),
  ic_score_container: require("./images/ic_score_container.png"),
  ic_user: require("./images/ic_user.png"),
  ic_flash_bookmark: require("./images/ic_flash_bookmark.png"),
  ic_flash_exam: require("./images/ic_flash_exam.png"),
  ic_flash_quick_set: require("./images/ic_flash_quick_set.png"),
  ic_flash_topic: require("./images/ic_flash_topic.png"),
  ic_cancel: require("./images/ic_cancel.png"),
  other_app: require("./images/other_app.png"),
  logo_prepare: require("./images/logo_prepare.png"),
  practice_bg: require("./images/practice_bg.png"),
  logo_white: require("./images/logo_white.png"),
  ic_reset: require("./images/ic_reset_data.png"),
  ic_review: require("./images/ic_review_app.png"),
  app_review_dialog: require("./images/app_review_dialog.jpg"),
  delete: require("./images/delete.png"),
  information: require("./images/information-button.png"),
  change: require("./images/change.png"),
  community: require("./images/group_users.png"),
  filter: require("./images/filter.png"),
  affiliate_image: require("./images/affiliate_image.jpg"),
  ic_font: require("./images/font.png"),
  ic_book_mark_unselected: require("./images/bookmark_unselected.png"),
  ic_book_mark_selected: require("./images/bookmark.png"),
  ic_network: require("./images/ic_network.png"),
  trainingcamp_logo: require("./images/trainingcamp-logo.webp"),
};

export const SVG_IMAGES = {
  crown: Crown,
  info: Info,
  check: Check,
  searchIcon: SearchIcon,
  filterIcon: FilterIcon,
  DownArrow: DownArrow,
  UpArrow: UpArrow,
  Bookmarks: Bookmarks,
  Book: Book,
  Clock: Clock,
  Lock: Lock,
  BookMarkSave: BookMarkSave,
  BackArrow: BackArrow,
  PracticeTestBG: PracticeTestBG,
  PracticeTestArt: PracticeTestArt,
  ic_practice_test: IcPracticeTest,
  IcRightIcon: IcRightIcon,
  Circle1: Circle1,
  Circle2: Circle2,
  Circle3: Circle3,
  ChangeIcon: ChangeIcon,
  homeIcon: HomeIcon,
  dashboardIcon: dashboardIcon,
};




